<div class="business-navbar__overlay-container">
    <div class="business-navbar__overlay-container__overlay" [ngClass]="{'business-navbar__overlay-container__overlay--showing': showing}" (click)="closeModal()"></div>
    <div class="business-navbar__overlay-container__wrapper">
        <div class="business-navbar__overlay-container__wrapper__pane" [ngStyle]="{'height': heightStyle}" [ngClass]="{'business-navbar__overlay-container__wrapper__pane--closing': closing, 'business-navbar__overlay-container__wrapper__pane--mobile': (mobile$ | async)}">
            <div class="business-navbar__overlay-container__wrapper__pane__header" [ngClass]="{'business-navbar__overlay-container__wrapper__pane__header--visible': (mobile$ | async)}">
                <i class="business-navbar__overlay-container__wrapper__pane__header__icon material-icons" (click)="closeModal()">close</i>
                <span class="business-navbar__overlay-container__wrapper__pane__header__title">{{ titleText }}</span>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</div>
